export var sortLeagues = function (x, y) { return x.defaultOrder - y.defaultOrder; };
//# sourceMappingURL=sortLeagues.js.map